import { Theme } from "@mui/material/styles/createTheme";
import { SxProps } from "@mui/system/styleFunctionSx";

export const sxProps: Record<string, SxProps<Theme>> = {
  serviceRequestWrapper: {
    background: (theme) => theme.palette.common.white,
  },
};
